export function renderPriceValue(num: number) {
  return `${num.toLocaleString('en-US').replace(/,/g, '.')}đ`;
}
